import React from 'react'
import './SingleTask.css'

const SingleTask = ({myref, body, indexclicked, onlinePerson}) => {
    const handleClick = () =>{
        indexclicked(myref)
    }

  return (
    <div className='personal-task-container' onClick={handleClick}>
        <div className='top-task-container-tab'>
            <div className='top-task-title-container'>
                <span>{body.title}</span>
                <div className='top-task-chat'><span>5</span></div>
            </div>
            <div className='date-task-container'>
                <div className='start-task-container'>
                    <span>Start:</span>
                    <span>{body.start}</span>
                </div>
                
                <div className='end-task-container'>
                    <span>End:</span>
                    <span>{body.stop}</span>
                </div>
            </div>
        </div>

        <div className='underline'/>

        <div className='btom-task-container-tab'>
            {body.participants.map((item, index)=>(
                <div key={index} className={`prt_image_container-${index+1}`} style={{backgroundImage: `url(${process.env.PUBLIC_URL + item.imgurl})`}}/>
            ))}
        </div>
    </div>
  )
}

export default SingleTask